<template>
  <v-menu
    content-class="menuCalendar"
    v-model="shortCalendar"
    offset-y
    location="bottom left"
    nudge-right="25"
    offset-x
    :close-on-click="false"
    :close-on-content-click="false"
  >
    <template #activator="{ props:menu }">
      <v-tooltip location="bottom">
        <template #activator="{ props:tooltip }">
          <v-icon
            v-bind="mergeProps(menu, tooltip)"
            class="second-menu-item"
            :icon="Icons.CALENDAR"
          />
        </template>
        <span>{{ t("navigation.tooltip.liveCoaching") }}</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-text>
        <cc-calendar
          initial-view="timeGridDay"
          :can-view-change="false"
          :control-rows="true"
        />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <cc-calendar-dialog />
        <v-spacer />
        <v-btn @click="shortCalendar = false">
          {{ t("common.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script setup lang="ts">
import {shortCalendar} from '@/composables/layout/baseLayout';
import {defineAsyncComponent, mergeProps} from 'vue';
import {Icons} from '@simpleforyou/client-core';
import {useI18n} from 'vue-i18n';

// Dieses Menue steckt im Layout, laedt also auf jeder Seite. Ein statischer
// Import zog FullCalendar (~1 MB) damit in den Entry-Chunk, obwohl das Menue
// erst beim Anklicken rendert. Asynchron geladen, wenn es gebraucht wird.
const CcCalendar = defineAsyncComponent(() => import('@/components/common/calendar/CcCalendar.vue'));
const CcCalendarDialog = defineAsyncComponent(() => import('@/components/common/calendar/CcCalendarDialog.vue'));

const {t} = useI18n();
</script>

<style scoped>

</style>
